import React, { useEffect, useRef, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import API_ENDPOINTS from '../../helperFunction/Constant';
import ApiHelper from '../../helperFunction/ApiHelper';
import { Toast } from 'primereact/toast';
import Layout from '../common/Layout';
import { useForm } from 'react-hook-form';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'

const AddBusinessCategory = () => {

    const { id } = useParams()
    const isEdit = id ? true : false
    const toast = useRef(null)
    const navigate = useNavigate()

    useEffect(() => {
        isEdit && getBusinessCategory()
    }, [])

    const schema = yup.object({
        businessCategoryName: yup.string().required("Name is required"),
        businessCategoryDescription: yup.string().required("Description is required"),
        isActive: yup.boolean(),
    });

    const { register, handleSubmit, reset, formState: { errors }, } = useForm({ resolver: yupResolver(schema), });

    const resetValue = () => {
        reset({
            businessCategoryName: '',
            businessCategoryDescription: null,
            isActive: '',
        })
    }

    const getBusinessCategory = () => {
        ApiHelper.get(`${API_ENDPOINTS.BUSINESS_CATEGORY}/${id}`).then((res) => {
            if (res.status === 200) {
                reset({
                    businessCategoryName: res.data.data.businessCategoryName,
                    businessCategoryDescription: res.data.data.businessCategoryDescription,
                    isActive: res.data.data.isActive,
                })
            }
        }).catch((error) => {
            console.log("Error: ", error);
        })
    }

    const onSubmit = (data) => {
        if (isEdit) {
            update(data)
        } else {
            add(data)
        }
    };
    const add = (data) => {
        ApiHelper.post(`${API_ENDPOINTS.BUSINESS_CATEGORY}/`, data).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
                setTimeout(() => {
                    navigate('/business-category')
                }, 900)
            }
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.message, life: 3000 })
        })
    };
    const update = (data) => {
        ApiHelper.put(`${API_ENDPOINTS.BUSINESS_CATEGORY}/${id}`, data).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
                setTimeout(() => {
                    navigate('/business-category')
                }, 900)
            }
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.message, life: 3000 })
        })
    };

    return (
        <>
            <Toast ref={toast} />
            <ConfirmDialog />
            <Layout>
                <div class="content-wrapper">
                    <div class="container-xxl flex-grow-1 container-p-y">
                        <div class="d-flex justify-content-between align-items-center py-3">
                            <h4 class="fw-bold py-3 mb-2">
                                <span class="d-flex text-muted fw-light"> 
                                    <p class="breadcrumb-item pageHeader active me-2 mb-0" aria-current="page" onClick={() => navigate('/business-category')}> Business Category </p> / <b className='mx-2'> {isEdit ? 'Edit' : "Add"} </b>
                                </span>
                            </h4>
                            <Link to="/business-category" class="btn btn-secondary">⬅ Go Back</Link>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="card mb-4">
                                    <div class="card-body">
                                        <form onSubmit={handleSubmit(onSubmit)}>
                                            <div class="row mb-3">
                                                <div class="col-md-3 mb-3">
                                                    <label class="form-label">Name</label>
                                                    <input type="text" name="businessCategoryName" class="form-control" {...register("businessCategoryName")} />
                                                    <small className="text-danger">{errors.businessCategoryName?.message}</small>
                                                </div>
                                                <div class="col-md-3 mb-3">
                                                    <label class="form-label">Description</label>
                                                    <textarea type="text" name="businessCategoryDescription" class="form-control" {...register("businessCategoryDescription")} />
                                                    <small className="text-danger">{errors.businessCategoryDescription?.message}</small>
                                                </div>
                                                <div class="col-md-3 mt-2">
                                                    <label class="form-label">Status</label>
                                                    <div class="form-check form-switch mb-2">
                                                        <input class="form-check-input mt-2" name="isActive" type="checkbox" id="flexSwitchCheckDefault" {...register("isActive")} />
                                                        <small className="text-danger">{errors.isActive?.message}</small>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mt-4">
                                                <button type="submit" class="btn btn-primary me-3">Save</button>
                                                <button type="button" onClick={() => resetValue()} class="btn btn-secondary reset-btn">Reset</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}

export default AddBusinessCategory
